import { Autocomplete, Stack, TextField } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Fragment, useState } from 'react';

import { FormButtonLink } from '@/components/management/formElements/FormButtonLink';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { OrganizationTable } from '@/components/management/table/OrganizationTable';
import type { Organization } from '@/modules/api/backend';
import { backendApiOrganizationsFindAllOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/management/organizations/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: OrganizationsRoute,
  beforeLoad: () => ({ breadcrumb: null }),
});

function OrganizationsRoute() {
  const { data: organizations } = useQuery(backendApiOrganizationsFindAllOptions());
  const [selectedOrg, setSelectedOrg] = useState<Organization | null>(null);

  return (
    <Fragment>
      <AdministrationHeader label="Organisationen" />
      <AdministrationBody>
        <Stack
          sx={{
            py: { sm: 2, lg: 0 },
          }}
        >
          <Autocomplete
            getOptionLabel={(option) => option.name}
            onChange={(_event, newValue) => setSelectedOrg(newValue)}
            options={organizations ?? []}
            sx={{ width: 432 }}
            value={selectedOrg}
            renderInput={(params) => (
              <TextField {...params} label="Organisation" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 0 } }} />
            )}
          />
          <Stack mb={{ xs: 2, lg: 9 }} mt={{ xs: 3, lg: 6 }}>
            <OrganizationTable organizationData={selectedOrg ? [selectedOrg] : (organizations ?? [])} />
          </Stack>
          <Stack alignItems="flex-end" direction="column">
            <FormButtonLink to="/management/organizations/create">Organisation hinzufügen</FormButtonLink>
          </Stack>
        </Stack>
      </AdministrationBody>
    </Fragment>
  );
}
